import "font-awesome/css/font-awesome.min.css";
import { useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import Editor from "./Editor";
import LoginPage from "./LoginPage";
import { Providers } from "./context";
import "./style/index.css";

export const loginCookieName = "sugar_editor_authentication";
export default function App() {
  return (
    <>
      <Providers>
        <BrowserRouter forceRefresh={true}>
          <Switch>
            <Route path="/login" component={LoginPage} />
            <Route path="/smv-test" component={Editor} />

            <Route path="/" component={Editor} />
          </Switch>
        </BrowserRouter>
      </Providers>
    </>
  );
}

function SugarModelViewerTest() {

  const [productId, setProductId] = useState( "" );
  const [companyId, setCompanyId] = useState( "" );

  return (
    
    <div style={{
      height: "100vh",
      width: "100vw",
      overflow: "hidden",
      display: "flex",
      flexDirection: "row",
    }}>
      <div>
        <input type="text" />
        <input type="" />
      </div>
      <script src="/static/js/sugar-model-viewer.js" type="module" />
      {/* <script src="https://s3.eu-central-1.amazonaws.com/cdn.sugartech/mottobucket/CDN/sugar-viewer/sugar-model-viewer-dev.js" type="module" /> */}
      <sugar-model-viewer
        id="modelViewer"
        ar
        material-search="true"
        interaction-prompt="none"
        product-id={productId}
        company_id={companyId}
        scrollable="pan-y"
        editor="true"
        template="advanced"
        joint-show=""
        showDimension="true"
        show-model-group
        camera-down-lock="false"
        camera-controls
        style={{ height: "100vh" }}
        highlight-enabled="true"
        highlight-color="FF0000"
        highlight-by="material"
        quick-look-browsers="safari chrome"
      />
    </div>
  );
}